export const phone = (rule, val, callback) => {
  if(!!val && !(/^1[3456789]\d{9}$/.test(val))) {
    callback(new Error('手机号码格式有误'))
  } else {
    callback()
  }
}

export const email = (rule, val, callback) => {
  if(!!val && !/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(val)) {
    callback(new Error('邮箱地址格式错误'))
  } else {
    // 如果为中国地址，则校验结尾是否为.com或.cn
    if (rule.chineseAddress) {
      if (!!val && !/(\.com)|(\.cn)$/.test(val)) {
        callback(new Error('邮箱地址结尾应为.com或.cn'))
      } else {
        callback()
      }
    } else {
      callback()
    }
  }
}

export const idCardSamlpe = (rule, val, callback) => {
  if(!!val && !/^[0-9a-zA-Z]{18}$/.test(val)) {
    callback(new Error('身份证号码格式错误'))
    return
  } else {
    callback()
  }
}

export const decimalNum = function(rule, value, callback){
  if (!value) {
    callback( )
    return
  }

  let rules = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/
  if(rules.test(value)){
      callback( )
  }else{
      callback(new Error('请输入合法的数字,最多两位小数'))
  }
}

export const numRule9 = function(rule, value, callback){
  if(/(^[0-9]{1,9}$)|(^[0-9]{1,9}[.]{1}[0-9]{1,2}$)/.test(value) && value >= 0){
    callback( )
  }else{
    callback(new Error('不超过9位数，最多两位小数'))
  }
}

// 不能输入空格
export const notSpace = function(rule, value, callback){
  if(/^\S*$/.test(value)){
    callback( )
  }else{
    callback(new Error('不能输入空格'))
  }
}

/**
 * 常用规则
 */
export const $rule = {
  required: { required: true, message: "此项必填", trigger: "change" },
  requiredArr: { required: true, message: "此项必填", trigger: "change", type: 'array' },
  requiredNum: { required: true, message: "此项必填", trigger: "blur", type: 'number' },
  requiredBlur: { required: true, message: "此项必填", trigger: "blur" },
}